import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';
import {DriverVehicleReservationCancelReasonEnum} from '@/services/api-clients';

export function driverVehicleReservationCancelReasonNameFilter(value: DriverVehicleReservationCancelReasonEnum) {
  switch (value) {
    case DriverVehicleReservationCancelReasonEnum.NotApprovedInTime: return i18n.t(LF.TimeToApproveIsExpired) as string;
    case DriverVehicleReservationCancelReasonEnum.VehicleUnavailable: return i18n.t(LF.VehicleUnavailable) as string;
    case DriverVehicleReservationCancelReasonEnum.CancelledByDriver: return i18n.t(LF.CancelledByDriver) as string;
    case DriverVehicleReservationCancelReasonEnum.CancelledByUser: return i18n.t(LF.CancelledByUser) as string;
    case DriverVehicleReservationCancelReasonEnum.ArrangementsChange: return i18n.t(LF.ArrangementsChange) as string;
  }
}
